"use strict";

import Dom from "common/Dom";
export const bindActions = function bindActions() {
  $(Dom.videoButtonWrapper).detach().insertBefore(".slick-list");
};
